import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import TicketDetail from "@/pages/TicketDetail";
import TaricTool from "@/pages/TaricTool";
import OpsHealth from "@/pages/OpsHealth";
import Declarations from "@/pages/Declarations";
import AuditLog from "@/pages/AuditLog";
import Threads from "@/pages/Threads";
import Users from "@/pages/Users";
import Leads from "@/pages/Leads";
import FiscalReps from "@/pages/FiscalReps";
import Usage from "@/pages/Usage";
import HealthChecks from "@/pages/HealthChecks";
import HealthCheckDetail from "@/pages/HealthCheckDetail";
import { Loader2 } from "lucide-react";

function Protected({ children }) {
  const { user, ready } = useAuth();
  if (!ready || user === null) return <div className="min-h-screen flex items-center justify-center bg-background"><Loader2 className="h-6 w-6 animate-spin text-zinc-500" /></div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function PublicOnly({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="min-h-screen flex items-center justify-center bg-background"><Loader2 className="h-6 w-6 animate-spin text-zinc-500" /></div>;
  if (user) return <Navigate to="/app" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
            <Route path="/register" element={<PublicOnly><Register /></PublicOnly>} />
            <Route path="/app" element={<Protected><Dashboard /></Protected>} />
            <Route path="/tickets/:ticketId" element={<Protected><TicketDetail /></Protected>} />
            <Route path="/taric" element={<Protected><TaricTool /></Protected>} />
            <Route path="/declarations" element={<Protected><Declarations /></Protected>} />
            <Route path="/health-checks" element={<Protected><HealthChecks /></Protected>} />
            <Route path="/health-checks/:hcId" element={<Protected><HealthCheckDetail /></Protected>} />
            <Route path="/threads" element={<Protected><Threads /></Protected>} />
            <Route path="/ops" element={<Protected><OpsHealth /></Protected>} />
            <Route path="/audit" element={<Protected><AuditLog /></Protected>} />
            <Route path="/users" element={<Protected><Users /></Protected>} />
            <Route path="/leads" element={<Protected><Leads /></Protected>} />
            <Route path="/fiscal-reps" element={<Protected><FiscalReps /></Protected>} />
            <Route path="/usage" element={<Protected><Usage /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" theme="dark" />
      </AuthProvider>
    </div>
  );
}

export default App;
